__turbopack_context__.v({
  "document_wrapper": "reddAW_document_wrapper",
  "sts_fix": "reddAW_sts_fix",
});
